import { render, staticRenderFns } from "./SaldoMaterial.vue?vue&type=template&id=5054d1c2&scoped=true&"
import script from "./SaldoMaterial.vue?vue&type=script&lang=js&"
export * from "./SaldoMaterial.vue?vue&type=script&lang=js&"
import style0 from "./SaldoMaterial.vue?vue&type=style&index=0&id=5054d1c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5054d1c2",
  null
  
)

export default component.exports